import React from 'react';

import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';

import { isMobileView } from 'constants/isMobileView';

import { Avatar } from 'uiToolkitV1/Avatar';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TextLabel } from 'uiToolkitV1/Typography';

const RELATION_TYPE = {
  REPORTEE: 'Direct team member',
  MANAGER: 'Manager',
  PEER: 'Peer',
  SKIP_REPORTEE: 'Skip team member',
  SKIP_MANAGER: 'Skip Manager',
};

const EmployeeData = (params) => {
  const { employeeMiniProfile } = params?.data?.employee?.value ?? {};
  const { relationType } = params?.data?.employee?.value ?? '';
  const { isOneOnOneSetup } = params?.data?.employee?.value ?? '';
  const { nextInstanceTS } = params?.data?.nextOneOnOne?.value ?? '';
  const oneOnoneSetupDate = nextInstanceTS ? format(new Date(nextInstanceTS * 1000), 'PPp') : '1:1 Not Setup';

  return (
    <Flex
      flexDir={isMobileView() && 'column'}
      w="100%"
      h="100%"
      alignItems={isMobileView() ? 'flex-start' : 'center'}
      mt={isMobileView() && '8px'}
    >
      <ListItemComp
        isBoldText={false}
        withoutBackground
        title={employeeMiniProfile?.displayName}
        subTitle={RELATION_TYPE[relationType] ?? ''}
        // eslint-disable-next-line react/no-unstable-nested-components
        LeftComponent={() => <Avatar src={employeeMiniProfile?.profilePhoto} />}
      />
      {isMobileView() && (
        <TextLabel ml={8} color={isOneOnOneSetup ? '#666666' : '#C62C02'}>
          {isOneOnOneSetup ? `Next 1:1 : ${oneOnoneSetupDate}` : oneOnoneSetupDate}
        </TextLabel>
      )}
    </Flex>
  );
};

export default EmployeeData;
